import React, { useState, useEffect } from "react";
import "./KurtaPajamaShowcase.css";
import { useNavigate } from "react-router-dom";

import shwal1 from "../../assets/shawls/1.png";
import shwal2 from "../../assets/shawls/2.png";
import shwal3 from "../../assets/shawls/3.png";
import shwal4 from "../../assets/shawls/4.png";
import shwal5 from "../../assets/shawls/5.png";
import shwal6 from "../../assets/shawls/6.png";
import shwal8 from "../../assets/shawls/7.png";
import shwal9 from "../../assets/shawls/8.png";
import shwal11 from "../../assets/shawls/9.png";
import shwal12 from "../../assets/shawls/10.png";

import base_url from "../../api";
import { Info, Trash2 } from "lucide-react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const kurtaPalette = [
  { name: "Ivory Mist", hex: "#f6f1e8" },
  { name: "Champagne", hex: "#eddcc2" },
  { name: "Rosewood", hex: "#7b2d3a" },
  { name: "Royal Indigo", hex: "#2a3f80" },
  { name: "Emerald Dew", hex: "#0d6f57" },
  { name: "Sunlit Mustard", hex: "#d6a12b" },
  { name: "Coral Clay", hex: "#d66f5c" },
  { name: "Midnight Teal", hex: "#013a4a" },
  { name: "Smoke Grey", hex: "#7c7c7c" },
  { name: "Jet Black", hex: "#111111" },
];

const pajamaPalette = kurtaPalette;

const kurtaFabrics = [
  "Cotton Satin",
  "Raw Silk",
  "Linen Blend",
  "Khadi Luxe",
  "Velvet Touch",
];

const pajamaFabrics = [
  "Mercerized Cotton",
  "Egyptian Cotton",
  "Linen",
  "Silk Blend",
  "Bamboo Flex",
];

const aiLooks = [
  {
    id: 1,
    title: "Festive Ivory Ensemble",
    image:
      "https://images.wholesalesalwar.com/2022y/October/35900/Grey-Silk-Traditional-Wear-Jacquard-Kurta-Pajama-2428.jpg",
  },
];

const shawlOptions = [
  { name: "shawl1", image: shwal1 },
  { name: "shawl2", image: shwal2 },
  { name: "shawl3", image: shwal3 },
  { name: "shawl4", image: shwal4 },
  { name: "shawl5", image: shwal5 },
  { name: "shawl6", image: shwal6 },
  { name: "shawl7", image: shwal8 },
  { name: "shawl8", image: shwal9 },
  { name: "shawl9", image: shwal11 },
  { name: "shawl10", image: shwal12 },
];

// Each look = one look
const createlook = (index = 0) => ({
  id: Date.now() + index,
  name: index === 0 ? "Main Look" : `Look ${index + 1}`,
  selectedKurtaColor: kurtaPalette[0],
  selectedPajamaColor: pajamaPalette[0],
  selectedKurtaFabric: kurtaFabrics[0],
  selectedPajamaFabric: pajamaFabrics[0],
  selectedShawl: shawlOptions[0],
  activeLook: aiLooks[0],
  isGenerating: false,
  quantity: 1, // ✅ initial quantity 1 for all looks
  recipients: [{ name: "", email: "" }], // per-look recipients (excluding admin)
});

const KurtaPajamaShowcase = () => {
  const navigate = useNavigate();
  const [looks, setlooks] = useState([createlook(0)]);
  const [admin, setAdmin] = useState({ name: "", email: "" }); // ✅ common admin
  const [statusMessage, setStatusMessage] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successOrderNo, setSuccessOrderNo] = useState(null);
  const [emailErrors, setEmailErrors] = useState({}); // Track email validation errors
  const [selectedCountry, setSelectedCountry] = useState("Canada"); // Default to Canada for CAD pricing

  // Comprehensive Currency and tax configuration for all countries
  // Note: exchangeRate is now fetched live from API, only code, symbol, and taxRate are stored here
  const CURRENCY_CONFIG = {
    "United States": {
      code: "USD",
      symbol: "$",
      taxRate: 0.08, // 8% sales tax (varies by state)
    },
    "Canada": {
      code: "CAD",
      symbol: "C$",
      taxRate: 0.13, // 13% HST/GST
    },
    "United Kingdom": {
      code: "GBP",
      symbol: "£",
      taxRate: 0.20, // 20% VAT
    },
    "Australia": {
      code: "AUD",
      symbol: "A$",
      taxRate: 0.10, // 10% GST
    },
    "Germany": {
      code: "EUR",
      symbol: "€",
      taxRate: 0.19, // 19% VAT
    },
    "France": {
      code: "EUR",
      symbol: "€",
      taxRate: 0.20, // 20% VAT
    },
    "Italy": {
      code: "EUR",
      symbol: "€",
      taxRate: 0.22, // 22% VAT
    },
    "Spain": {
      code: "EUR",
      symbol: "€",
      taxRate: 0.21, // 21% VAT
    },
    "Netherlands": {
      code: "EUR",
      symbol: "€",
      taxRate: 0.21, // 21% VAT
    },
    "Belgium": {
      code: "EUR",
      symbol: "€",
      taxRate: 0.21, // 21% VAT
    },
    "Switzerland": {
      code: "CHF",
      symbol: "CHF",
      taxRate: 0.077, // 7.7% VAT
    },
    "Japan": {
      code: "JPY",
      symbol: "¥",
      taxRate: 0.10, // 10% consumption tax
    },
    "China": {
      code: "CNY",
      symbol: "¥",
      taxRate: 0.13, // 13% VAT
    },
    "India": {
      code: "INR",
      symbol: "₹",
      taxRate: 0.18, // 18% GST
    },
    "Singapore": {
      code: "SGD",
      symbol: "S$",
      taxRate: 0.09, // 9% GST
    },
    "Hong Kong": {
      code: "HKD",
      symbol: "HK$",
      taxRate: 0.00, // No VAT
    },
    "United Arab Emirates": {
      code: "AED",
      symbol: "AED",
      taxRate: 0.05, // 5% VAT
    },
    "Saudi Arabia": {
      code: "SAR",
      symbol: "SAR",
      taxRate: 0.15, // 15% VAT
    },
    "South Africa": {
      code: "ZAR",
      symbol: "R",
      taxRate: 0.15, // 15% VAT
    },
    "Brazil": {
      code: "BRL",
      symbol: "R$",
      taxRate: 0.17, // 17% average tax
    },
    "Mexico": {
      code: "MXN",
      symbol: "$",
      taxRate: 0.16, // 16% VAT
    },
    "Argentina": {
      code: "ARS",
      symbol: "$",
      taxRate: 0.21, // 21% VAT
    },
    "New Zealand": {
      code: "NZD",
      symbol: "NZ$",
      taxRate: 0.15, // 15% GST
    },
    "South Korea": {
      code: "KRW",
      symbol: "₩",
      taxRate: 0.10, // 10% VAT
    },
    "Thailand": {
      code: "THB",
      symbol: "฿",
      taxRate: 0.07, // 7% VAT
    },
    "Malaysia": {
      code: "MYR",
      symbol: "RM",
      taxRate: 0.10, // 10% SST
    },
    "Indonesia": {
      code: "IDR",
      symbol: "Rp",
      taxRate: 0.11, // 11% VAT
    },
    "Philippines": {
      code: "PHP",
      symbol: "₱",
      taxRate: 0.12, // 12% VAT
    },
    "Vietnam": {
      code: "VND",
      symbol: "₫",
      taxRate: 0.10, // 10% VAT
    },
    "Turkey": {
      code: "TRY",
      symbol: "₺",
      taxRate: 0.20, // 20% VAT
    },
    "Russia": {
      code: "RUB",
      symbol: "₽",
      taxRate: 0.20, // 20% VAT
    },
    "Poland": {
      code: "PLN",
      symbol: "zł",
      taxRate: 0.23, // 23% VAT
    },
    "Sweden": {
      code: "SEK",
      symbol: "kr",
      taxRate: 0.25, // 25% VAT
    },
    "Norway": {
      code: "NOK",
      symbol: "kr",
      taxRate: 0.25, // 25% VAT
    },
    "Denmark": {
      code: "DKK",
      symbol: "kr",
      taxRate: 0.25, // 25% VAT
    },
    "Finland": {
      code: "EUR",
      symbol: "€",
      taxRate: 0.24, // 24% VAT
    },
    "Ireland": {
      code: "EUR",
      symbol: "€",
      taxRate: 0.23, // 23% VAT
    },
    "Portugal": {
      code: "EUR",
      symbol: "€",
      taxRate: 0.23, // 23% VAT
    },
    "Greece": {
      code: "EUR",
      symbol: "€",
      taxRate: 0.24, // 24% VAT
    },
    "Austria": {
      code: "EUR",
      symbol: "€",
      taxRate: 0.20, // 20% VAT
    },
    "Czech Republic": {
      code: "CZK",
      symbol: "Kč",
      taxRate: 0.21, // 21% VAT
    },
    "Hungary": {
      code: "HUF",
      symbol: "Ft",
      taxRate: 0.27, // 27% VAT
    },
    "Romania": {
      code: "RON",
      symbol: "lei",
      taxRate: 0.19, // 19% VAT
    },
    "Israel": {
      code: "ILS",
      symbol: "₪",
      taxRate: 0.17, // 17% VAT
    },
    "Egypt": {
      code: "EGP",
      symbol: "E£",
      taxRate: 0.14, // 14% VAT
    },
    "Nigeria": {
      code: "NGN",
      symbol: "₦",
      taxRate: 0.075, // 7.5% VAT
    },
    "Kenya": {
      code: "KES",
      symbol: "KSh",
      taxRate: 0.16, // 16% VAT
    },
    "Chile": {
      code: "CLP",
      symbol: "$",
      taxRate: 0.19, // 19% VAT
    },
    "Colombia": {
      code: "COP",
      symbol: "$",
      taxRate: 0.19, // 19% VAT
    },
    "Peru": {
      code: "PEN",
      symbol: "S/",
      taxRate: 0.18, // 18% IGV
    },
  };

  // Base currency and prices (set in CAD)
  const BASE_CURRENCY_CODE = "CAD";
  const BASE_PRICE_KURTA = 44.99; // Customized Kurtas (CAD)
  const BASE_PRICE_SHAWL = 33.99; // Shawls (CAD)
  const BASE_SHIPPING_CHARGES = 35.00; // Base shipping (CAD)
  const FIXED_TAX_RATE = 0.13; // Fixed tax rate (13% - Canada's rate) - all amounts stay the same

  // Helper function to format currency (some currencies don't use decimals)
  const formatCurrency = (amount, currencyCode) => {
    const noDecimalCurrencies = ["JPY", "KRW", "VND", "IDR", "CLP", "COP"];
    if (noDecimalCurrencies.includes(currencyCode)) {
      return Math.round(amount).toLocaleString();
    }
    return amount.toFixed(2);
  };

  // Check if user is logged in
  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    
    if (token && user) {
      try {
        const userData = JSON.parse(user);
        setLoggedInUser(userData);
        setIsLoggedIn(true);
        // Auto-fill admin name and email from logged-in user (non-editable)
        setAdmin({ 
          name: userData.name || "", 
          email: userData.email || "" 
        });
      } catch (err) {
        console.error("Error parsing user data:", err);
        setIsLoggedIn(false);
        setAdmin({ name: "", email: "" });
      }
    } else {
      setIsLoggedIn(false);
      setAdmin({ name: "", email: "" });
    }
  }, []);

  // Email validation function using regex
  const validateEmail = (email) => {
    if (!email || !email.trim()) {
      return "Email is required";
    }
    
    // Comprehensive email regex pattern
    // Matches: user@domain.com, user.name@domain.co.uk, user+tag@example.com
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    
    const trimmedEmail = email.trim();
    
    if (!emailRegex.test(trimmedEmail)) {
      return "Please enter a valid email address";
    }
    
    // Additional check: email should not start or end with dot, and should have at least one dot after @
    if (trimmedEmail.startsWith('.') || trimmedEmail.endsWith('.') || 
        trimmedEmail.includes('..') || 
        !trimmedEmail.includes('@') ||
        trimmedEmail.split('@')[1]?.split('.').length < 2) {
      return "Please enter a valid email address";
    }
    
    return null; // Valid email
  };

  const totalQuantity = looks.reduce(
    (sum, b) => sum + (b.quantity || 0),
    0
  );

  // European countries list
  const EUROPEAN_COUNTRIES = [
    "United Kingdom", "Germany", "France", "Italy", "Spain", "Netherlands", 
    "Belgium", "Switzerland", "Poland", "Sweden", "Norway", "Denmark", 
    "Finland", "Ireland", "Portugal", "Greece", "Austria", "Czech Republic", 
    "Hungary", "Romania", "Russia", "Turkey"
  ];

  // Get current currency configuration - only changes currency code, not price
  const getCurrencyConfig = () => {
    // Canada → CAD
    if (selectedCountry === "Canada") {
      return {
        code: "CAD",
        symbol: "", // No symbol, only code
        taxRate: FIXED_TAX_RATE,
        exchangeRate: 1.0
      };
    }
    
    // European countries → GBP
    if (EUROPEAN_COUNTRIES.includes(selectedCountry)) {
      return {
        code: "GBP",
        symbol: "", // No symbol, only code
        taxRate: FIXED_TAX_RATE,
        exchangeRate: 1.0
      };
    }
    
    // All other countries → USD
    return {
      code: "USD",
      symbol: "", // No symbol, only code
      taxRate: FIXED_TAX_RATE,
      exchangeRate: 1.0
    };
  };

  const currency = getCurrencyConfig();

  // Prices remain the same, only symbol changes
  const pricePerKurta = BASE_PRICE_KURTA;
  const pricePerShawl = BASE_PRICE_SHAWL;
  const shippingCharges = BASE_SHIPPING_CHARGES;

  // Calculate price for each look
  // Each look includes: 1 Kurta + 1 Pajama (included) + 1 Shawl (optional)
  const looksWithPrice = looks.map(look => {
    const kurtaPrice = pricePerKurta; // Customized Kurta price
    const shawlPrice = look.selectedShawl ? pricePerShawl : 0; // Shawl price (0 if no shawl selected)
    const lookPricePerUnit = kurtaPrice + shawlPrice; // Price per complete outfit (Kurta + Pajama + optional Shawl)
    const lookTotal = (look.quantity || 0) * lookPricePerUnit;
    
    return {
      ...look,
      price: lookTotal,
      pricePerUnit: lookPricePerUnit,
    };
  });

  // Calculate subtotal (sum of all look prices)
  const subtotal = looksWithPrice.reduce((sum, look) => sum + look.price, 0);

  // Calculate tax - using fixed rate so prices stay the same, only symbol changes
  const taxAmount = subtotal * FIXED_TAX_RATE;

  // Calculate total (subtotal + tax + shipping)
  const totalAmount = subtotal + taxAmount + shippingCharges;

  const handleAddlook = () => {
    setlooks((prev) => [...prev, createlook(prev.length)]);
    toast.success("Scroll down to view new Look!");

  };

  const updatelook = (id, patch) => {
    setlooks((prev) =>
      prev.map((b) => (b.id === id ? { ...b, ...patch } : b))
    );
  };

  const handleGenerateImage = async (look) => {
    updatelook(look.id, { isGenerating: true });

    try {
      const payload = {
        kurtaColor: look.selectedKurtaColor.name,
        pajamaColor: look.selectedPajamaColor.name,
        // Only include shawlDesign if shawl is selected (handle null shawl)
        shawlDesign: look.selectedShawl?.name || null,
      };

      const res = await fetch(`${base_url}/generate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      // Check if the response has an error
      if (!res.ok || data.error) {
        console.error("API Error:", data.error || data);
        toast.error(data.error || "Error generating AI look. Please try again.");
        return;
      }

      // If the image was saved locally, construct the full URL
      let imageUrl = data.imageUrl;
      if (data.saved && imageUrl && imageUrl.startsWith("/apis/")) {
        // base_url is like "http://localhost:5000/apis"
        // imageUrl is like "/apis/Looks/filename.jpg"
        // We need: "http://localhost:5000/apis/Looks/filename.jpg"
        // So: base_url + imageUrl.replace("/apis", "")
        const serverBase = base_url.replace(/\/apis\/?$/, ""); // Remove /apis from end
        imageUrl = `${serverBase}${imageUrl}`;
      }
      
      if (!imageUrl) {
        toast.error("No image URL received from server.");
        return;
      }
      
      updatelook(look.id, {
        activeLook: {
          ...look.activeLook,
          image: imageUrl,
        },
      });
      
      // Show success message if image was saved
      if (data.saved) {
        toast.success("AI look generated and saved successfully!");
      } else {
        toast.success("AI look generated successfully!");
      }
    } catch (err) {
      console.error("Error generating AI look:", err);
      toast.error("Error generating AI look. Please try again.");
    } finally {
      updatelook(look.id, { isGenerating: false });
    }
  };

  // per-look recipients
  const handleRecipientChange = (lookId, idx, field, value) => {
    setlooks((prev) =>
      prev.map((b) => {
        if (b.id !== lookId) return b;
        const nextRecipients = [...b.recipients];
        nextRecipients[idx] = {
          ...nextRecipients[idx],
          [field]: value,
        };
        return { ...b, recipients: nextRecipients };
      })
    );
  };

  const handleAddRecipient = (lookId) => {
    setlooks((prev) =>
      prev.map((b) =>
        b.id === lookId
          ? {
            ...b,
            recipients: [...b.recipients, { name: "", email: "" }],
          }
          : b
      )
    );
  };
  const handleDeletelook = (id) => {
    setlooks((prev) => {
      if (prev.length === 1) return prev; // ✅ prevent deleting last look
      return prev.filter((b) => b.id !== id);
    });
  };

  const handleDeleteRecipient = (lookId, idx) => {
    setlooks((prev) =>
      prev.map((b) => {
        if (b.id !== lookId) return b;
        const nextRecipients = b.recipients.filter((_, i) => i !== idx);
        return { ...b, recipients: nextRecipients };
      })
    );
  };

  // Validate admin email
  const adminEmailError = validateEmail(admin.email);
  const adminValid = admin.name.trim() && admin.email.trim() && !adminEmailError;

  // Validate all recipient emails
  const allRecipientsValid = looks.every((b) =>
    b.recipients.every((r) => {
      const emailError = validateEmail(r.email);
      return r.name.trim() && r.email.trim() && !emailError;
    })
  );

  const canSendMail =
    adminValid &&
    looks.length > 0 &&
    looks.every((b) => b.quantity > 0 && b.recipients.length > 0) &&
    allRecipientsValid;

  // Helper function to scroll to an element
  const scrollToElement = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Focus on the input field if it exists
      const input = element.querySelector('input') || element;
      if (input && input.focus) {
        setTimeout(() => input.focus(), 300);
      }
    }
  };

  const handleSendMail = async () => {
    // Check if user is logged in
    if (!isLoggedIn) {
      toast.error("Please login to send measurement invites");
      setTimeout(() => {
        navigate("/login");
      }, 1500);
      return;
    }

    // Validate all fields before submission
    const errors = {};
    
    // Validate admin name
    if (!admin.name || !admin.name.trim()) {
      errors["admin-name"] = "Admin name is required";
    }
    
    // Validate admin email
    const adminErr = validateEmail(admin.email);
    if (adminErr) {
      errors["admin"] = adminErr;
    }
    
    // Validate all recipient fields
    looks.forEach((look) => {
      if (!look.quantity || look.quantity <= 0) {
        errors[`quantity-${look.id}`] = "Quantity must be at least 1";
      }
      
      if (!look.recipients || look.recipients.length === 0) {
        errors[`recipients-${look.id}`] = "At least one recipient is required";
      }
      
      look.recipients.forEach((recipient, idx) => {
        if (!recipient.name || !recipient.name.trim()) {
          errors[`recipient-name-${look.id}-${idx}`] = "Recipient name is required";
        }
        
        const emailErr = validateEmail(recipient.email);
        if (emailErr) {
          errors[`recipient-${look.id}-${idx}`] = emailErr;
        }
      });
    });
    
    // If there are validation errors, show them, scroll to first error, and prevent submission
    if (Object.keys(errors).length > 0) {
      setEmailErrors(errors);
      
      // Find the first error and scroll to it
      let firstErrorId = null;
      
      // Check admin name error first
      if (errors["admin-name"]) {
        firstErrorId = "admin-name-input";
      }
      // Check admin email error
      else if (errors["admin"]) {
        firstErrorId = "admin-email-input";
      }
      // Check quantity errors
      else if (Object.keys(errors).find(key => key.startsWith("quantity-"))) {
        const quantityErrorKey = Object.keys(errors).find(key => key.startsWith("quantity-"));
        const lookId = quantityErrorKey.split("-")[1];
        firstErrorId = `quantity-input-${lookId}`;
    }
      // Check recipient errors
      else {
        // Find first recipient error
        const recipientErrorKey = Object.keys(errors).find(key => 
          key.startsWith("recipient-name-") || key.startsWith("recipient-")
        );
        if (recipientErrorKey) {
          const parts = recipientErrorKey.split("-");
          if (recipientErrorKey.startsWith("recipient-name-")) {
            // recipient-name-{lookId}-{idx}
            firstErrorId = `recipient-name-${parts[2]}-${parts[3]}`;
          } else {
            // recipient-{lookId}-{idx}
            firstErrorId = `recipient-email-${parts[1]}-${parts[2]}`;
          }
        }
      }
      
      if (firstErrorId) {
        scrollToElement(firstErrorId);
      }
      
      return;
    }
    
    // Clear any previous errors
    setEmailErrors({});

    const payload = {
      adminName: admin.name,
      adminEmail: admin.email,
      totalQuantity,
      looks: looks.map((b) => ({
        lookName: b.name,
        lookTitle: b.activeLook.title,
        image: b.activeLook.image,
        kurtaColor: b.selectedKurtaColor.name,
        pajamaColor: b.selectedPajamaColor.name,
        kurtaFabric: b.selectedKurtaFabric,
        pajamaFabric: b.selectedPajamaFabric,
        shawl: b.selectedShawl?.name || null,
        quantity: b.quantity,
        recipients: b.recipients,
      })),
    };

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${base_url}/measurementInvite`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.success) {
        // Show success popup instead of immediate redirect
        setSuccessOrderNo(data.orderNo);
        setShowSuccessPopup(true);
      } else {
        setStatusMessage("Something went wrong");
      
    }
  } catch (err) {
    console.error(err);
    setStatusMessage("Server error");
  }
};

  const handlePopupOk = () => {
    setShowSuccessPopup(false);
    // Redirect to profile with measurements tab and order number
    if (successOrderNo) {
      navigate(`/profile?tab=measurements&orderNo=${successOrderNo}`);
    } else {
      navigate(`/profile?tab=measurements`);
    }
  };

return (
  <div className="kps-multi-page">
    {/* Success Popup */}
    {showSuccessPopup && (
      <div className="popup-overlay">
        <div className="popup-box success-popup">
          <div className="popup-icon">✓</div>
          <h3>Measurement Emails Sent Successfully!</h3>
          <p>
            All recipients have been notified via email to fill out the measurement form.
            <br />
            <strong>Please inform all users to check their email (including spam folder) and complete the measurement form.</strong>
          </p>
          <p className="popup-note">
            You can track the submission status in your profile's Measurements tab.
          </p>
          <button
            type="button"
            onClick={handlePopupOk}
            className="popup-ok-btn"
          >
            OK
          </button>
        </div>
      </div>
    )}

    {/* Top header with Add look */}
    <div className="kps-multi-header">
      <div>
        <p className="eyebrow">Kurta · Pajama · Measurement Drive</p>
        <h1>Create multiple looks & send measurement invites</h1>
      </div>
      <button
        type="button"
        className="look-add-btn mobile-none"
        onClick={handleAddlook}
      >
        + Add a new style look
      </button>
    </div>

    {/* lookS */}
    {looks.map((look, idx) => (
      <section
        className="kps-layout look-layout"
        key={look.id}
      >
        {/* LEFT: image + generate for this look */}
        <div className="kps-left">
          <div className="kps-image-box">
            {look.isGenerating ? (
              <div className="kps-loading">
                <div className="kps-spinner" />
                <p style={{ color: "#fff", marginTop: "12px" }}>
                  Generating your AI look…
                </p>
              </div>
            ) : (
              <img
                src={look.activeLook.image}
                alt={look.activeLook.title}
              />
            )}

            <div className="kps-image-meta">
              <p>{look.name}</p>
              <span>{look.activeLook.title}</span>
              <button
                type="button"
                onClick={() => handleGenerateImage(look)}
                disabled={look.isGenerating}
                className="kps-generate-btn"
              >
                {look.isGenerating ? "Generating..." : "Generate AI Look"}
              </button>
            </div>
          </div>
        </div>

        {/* RIGHT: controls for this look */}
        <div className="kps-right">
          <div className="look-name">
            {/* <p className="eyebrow">Look {idx + 1}</p> */}
            <h1>Pick colors, fabrics & recipients</h1>

            <div className="look-name-row">
              <span>Look Name:</span>

              <input
                type="text"
                value={look.name}
                onChange={(e) =>
                  updatelook(look.id, { name: e.target.value })
                }
                placeholder={`Look ${idx + 1}`}
              />

              <button
                type="button"
                className="delete-look-btn"
                onClick={() => handleDeletelook(look.id)}
                title="Delete this look"
                disabled={looks.length === 1}
              >
                <Trash2 size={18} />
              </button>
            </div>


          </div>
          <br></br>
          {/* Kurta palette */}
          <div className="palette-section">
            <h2>Kurta color palette</h2>
            <div className="palette-grid">
              {kurtaPalette.map((color) => (
                <button
                  key={color.name}
                  type="button"
                  className={`color-pill ${look.selectedKurtaColor.name === color.name
                    ? "active"
                    : ""
                    }`}
                  style={{ background: color.hex }}
                  aria-label={color.name}
                  onClick={() =>
                    updatelook(look.id, {
                      selectedKurtaColor: color,
                    })
                  }
                />
              ))}
            </div>
            <div className="fabric-row">
              <span>Fabric:</span>
              <div className="fabric-chips">
                {kurtaFabrics.map((fabric) => (
                  <button
                    key={fabric}
                    type="button"
                    className={`chip ${look.selectedKurtaFabric === fabric ? "active" : ""
                      }`}
                    onClick={() =>
                      updatelook(look.id, {
                        selectedKurtaFabric: fabric,
                      })
                    }
                  >
                    {fabric}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Pajama palette */}
          <div className="palette-section">
            <h2>Pyjama color palette</h2>
            <div className="palette-grid">
              {pajamaPalette.map((color) => (
                <button
                  key={color.name}
                  type="button"
                  className={`color-pill ${look.selectedPajamaColor.name === color.name
                    ? "active"
                    : ""
                    }`}
                  style={{ background: color.hex }}
                  aria-label={color.name}
                  onClick={() =>
                    updatelook(look.id, {
                      selectedPajamaColor: color,
                    })
                  }
                />
              ))}
            </div>
            <div className="fabric-row">
              <span>Fabric:</span>
              <div className="fabric-chips">
                {pajamaFabrics.map((fabric) => (
                  <button
                    key={fabric}
                    type="button"
                    className={`chip ${look.selectedPajamaFabric === fabric ? "active" : ""
                      }`}
                    onClick={() =>
                      updatelook(look.id, {
                        selectedPajamaFabric: fabric,
                      })
                    }
                  >
                    {fabric}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Shawl collection */}
          <div className="palette-section">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
              <h2 style={{ margin: 0 }}>Shawl collection</h2>
              {look.selectedShawl && (
                <button
                  type="button"
                  className="look-add-btn"
                  onClick={() =>
                    updatelook(look.id, {
                      selectedShawl: null,
                    })
                  }
                  style={{ 
                    padding: "8px 16px", 
                    fontSize: "14px",
                    backgroundColor: "#dc3545",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px"
                  }}
                  title="Remove shawl from this look"
                >
                  <Trash2 size={16} />
                  Remove Shawl
                </button>
              )}
            </div>
            {look.selectedShawl ? (
            <div className="shawl-grid">
              {shawlOptions.map((shawl) => (
                <button
                  key={shawl.name}
                  type="button"
                    className={`shawl-item ${look.selectedShawl?.name === shawl.name ? "active" : ""
                    }`}
                  onClick={() =>
                    updatelook(look.id, {
                      selectedShawl: shawl,
                    })
                  }
                  aria-label={shawl.name}
                >
                  <img src={shawl.image} alt={shawl.name} />
                </button>
              ))}
            </div>
            ) : (
              <div style={{ 
                padding: "20px", 
                textAlign: "center", 
                backgroundColor: "#f8f9fa", 
                borderRadius: "8px",
                border: "2px dashed #dee2e6"
              }}>
                <p style={{ margin: "0 0 12px 0", color: "#6c757d" }}>No shawl selected</p>
                <button
                  type="button"
                  className="look-add-btn"
                  onClick={() =>
                    updatelook(look.id, {
                      selectedShawl: shawlOptions[0],
                    })
                  }
                  style={{ marginTop: "8px" }}
                >
                  Select a Shawl
                </button>
              </div>
            )}
          </div>

          {/* Quantity */}
          <div className="quantity-section">
            <div>
              <h2>Quantity</h2>
              <p>How many outfits in this look?</p>
            </div>
            <div className="quantity-controls">
              <button
                type="button"
                onClick={() => {
                  if (look.quantity > 1) {
                    const newQty = look.quantity - 1;

                    updatelook(look.id, { quantity: newQty });
                    handleDeleteRecipient(look.id, newQty - 1); // remove last recipient
                  }
                }}
              >
                -
              </button>

              <input
                id={`quantity-input-${look.id}`}
                type="number"
                min="1"
                max="50"
                value={look.quantity}
                onChange={(e) => {
                  const newQty = Math.max(1, Number(e.target.value) || 1);
                  const diff = newQty - look.quantity;

                  updatelook(look.id, { quantity: newQty });

                  if (diff > 0) {
                    // add recipients
                    for (let i = 0; i < diff; i++) handleAddRecipient(look.id);
                  } else if (diff < 0) {
                    // remove recipients
                    for (let i = diff; i < 0; i++) {
                      handleDeleteRecipient(look.id, look.recipients.length - 1);
                    }
                  }
                }}
              />

              <button
                type="button"
                onClick={() => {
                  const newQty = look.quantity + 1;

                  updatelook(look.id, { quantity: newQty });
                  handleAddRecipient(look.id);
                }}
              >
                +
              </button>

            </div>
          </div>

          {/* Emails for this look */}
          <div className="emails-section">
            <h2>Recipients for this look</h2>
            <p>
              These people will get measurement forms for{" "}
              <strong>{look.name}</strong>.
            </p>
            <div className="email-grid">
              {look.recipients.map((item, rIdx) => (
                <div key={rIdx} className="email-item">
                  <div className="person-header">
                    <button
                      type="button"
                      className="delete-btn"
                      onClick={() =>
                        handleDeleteRecipient(look.id, rIdx)
                      }
                      title="Remove"
                    >
                      <Trash2 size={18} />
                    </button>
                  </div>
                  <label id={`recipient-name-${look.id}-${rIdx}`}>
                    <span style={{ whiteSpace: 'nowrap' }}>Full Name <span className="required-asterisk">*</span></span>
                    <input
                      type="text"
                      value={item.name}
                      onChange={(e) => {
                        handleRecipientChange(
                          look.id,
                          rIdx,
                          "name",
                          e.target.value
                        );
                        // Clear error when user starts typing
                        const errorKey = `recipient-name-${look.id}-${rIdx}`;
                        if (emailErrors[errorKey]) {
                          setEmailErrors((prev) => {
                            const updated = { ...prev };
                            delete updated[errorKey];
                            return updated;
                          });
                      }
                      }}
                      placeholder="Full Name"
                      className={emailErrors[`recipient-name-${look.id}-${rIdx}`] ? "input-error" : ""}
                    />
                    {emailErrors[`recipient-name-${look.id}-${rIdx}`] && (
                      <span className="email-error-message">
                        {emailErrors[`recipient-name-${look.id}-${rIdx}`]}
                      </span>
                    )}
                  </label>
                  <br></br>
                  <label id={`recipient-email-${look.id}-${rIdx}`}>
                    <span style={{ whiteSpace: 'nowrap' }}>Email Address <span className="required-asterisk">*</span></span>
                    <input
                      type="email"
                      value={item.email}
                      onChange={(e) =>
                        handleRecipientChange(
                          look.id,
                          rIdx,
                          "email",
                          e.target.value
                        )
                      }
                      onBlur={(e) => {
                        if (e.target.value) {
                          const error = validateEmail(e.target.value);
                          const errorKey = `recipient-${look.id}-${rIdx}`;
                          if (error) {
                            setEmailErrors((prev) => ({ ...prev, [errorKey]: error }));
                          } else {
                            setEmailErrors((prev) => {
                              const updated = { ...prev };
                              delete updated[errorKey];
                              return updated;
                            });
                          }
                        }
                      }}
                      placeholder="Email Address"
                      className={emailErrors[`recipient-${look.id}-${rIdx}`] ? "input-error" : ""}
                    />
                    {emailErrors[`recipient-${look.id}-${rIdx}`] && (
                      <span className="email-error-message">
                        {emailErrors[`recipient-${look.id}-${rIdx}`]}
                      </span>
                    )}
                  </label>
                </div>
              ))}
            </div>
            <br></br>
            <button
              type="button"
              className="look-add-btn"
              onClick={() => handleAddRecipient(look.id)}
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
                <path d="M8 3.5V12.5M3.5 8H12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Add another person
            </button>
          </div>

          {/* Per-look summary */}
          <div className="selection-summary" style={{ marginTop: 16 }}>
            <p>
              Kurta: <strong>{look.selectedKurtaColor.name}</strong> •{" "}
              {look.selectedKurtaFabric}
            </p>
            <p>
              Pyjama: <strong>{look.selectedPajamaColor.name}</strong> •{" "}
              {look.selectedPajamaFabric}
            </p>
            <p>
              Shawl: <strong>{look.selectedShawl ? look.selectedShawl.name : "None"}</strong>
            </p>
            <p>Quantity in this look: {look.quantity}</p>
          </div>
          <br></br>
          <div>  <button
            type="button"
            className="look-add-btn w-100"
            onClick={handleAddlook}
          >
            + Add new style look
          </button></div>

        </div>
      </section>
    ))}

    {/* COMMON ADMIN SECTION */}
    {!isLoggedIn && (
      <div className="login-prompt-wrapper">
        <div className="login-prompt">
          <div className="login-prompt-icon">🔐</div>
          <div className="login-prompt-content">
            <h3>Login Required</h3>
            <p>Please login to send measurement invites to recipients and manage your orders.</p>
          </div>
          <button
            type="button"
            onClick={() => navigate("/login")}
            className="login-prompt-btn"
          >
            Login Now
          </button>
        </div>
      </div>
    )}
       <div className="admin-section">
      <h2>Admin (common for all looks) &nbsp;
        <div className="tooltip">
          <Info size={16} />
          <span className="tooltiptext">
            <p>This person will receive payment & delivery info for every look.</p>
          </span>
        </div>
      </h2>
      <p>This person will receive payment & delivery info for every look.</p>
      <div className="admin-grid">
        <div className="admin-field">
          <label id="admin-name-input">
            Admin Name
            <input
              type="text"
              value={admin.name}
              readOnly={isLoggedIn}
              placeholder={loggedInUser ? loggedInUser.name : "Login before entering admin email"}
              disabled={!isLoggedIn}
              className={isLoggedIn ? "read-only-input" : emailErrors["admin-name"] ? "input-error" : ""}
              onChange={(e) => {
                if (!isLoggedIn) {
                  setAdmin({ ...admin, name: e.target.value });
                  // Clear error when user starts typing
                  if (emailErrors["admin-name"]) {
                    setEmailErrors((prev) => {
                      const updated = { ...prev };
                      delete updated["admin-name"];
                      return updated;
                    });
                  }
                }
              }}
            />
            {emailErrors["admin-name"] && (
              <span className="email-error-message">{emailErrors["admin-name"]}</span>
            )}
          </label>
        </div>
        <div className="admin-field">
          <label id="admin-email-input">
            <span style={{ whiteSpace: 'nowrap' }}>Admin Email <span className="required-asterisk">*</span></span>
            <div className="admin-email-row">
              <input
                type="email"
                value={admin.email}
                readOnly={isLoggedIn}
                placeholder={loggedInUser ? loggedInUser.email : "Login before entering admin email"}
                disabled={!isLoggedIn}
                className={isLoggedIn ? "read-only-input" : emailErrors["admin"] ? "input-error" : ""}
                onChange={(e) => {
                  if (!isLoggedIn) {
                    setAdmin({ ...admin, email: e.target.value });
                    // Clear error when user starts typing
                    if (emailErrors["admin"]) {
                      setEmailErrors((prev) => {
                        const updated = { ...prev };
                        delete updated["admin"];
                        return updated;
                      });
                    }
                  }
                }}
                onBlur={(e) => {
                  if (!isLoggedIn && e.target.value) {
                    const error = validateEmail(e.target.value);
                    if (error) {
                      setEmailErrors((prev) => ({ ...prev, admin: error }));
                    } else {
                      setEmailErrors((prev) => {
                        const updated = { ...prev };
                        delete updated["admin"];
                        return updated;
                      });
                    }
                  }
                }}
              />
            </div>
            {emailErrors["admin"] && (
              <span className="email-error-message">{emailErrors["admin"]}</span>
            )}
          </label>
        </div>
      </div>
    </div>
    {/* Country Selection Section */}
    <div className="admin-section">
      <h2>Shipping Destination & Currency</h2>
      <p>Select the country where the order will be shipped. Currency code will be adjusted accordingly.</p>
      <div className="admin-grid">
        <div className="admin-field">
          <label>
            <span style={{ whiteSpace: 'nowrap' }}>Country of Origin <span className="required-asterisk">*</span></span>
            <select
              value={selectedCountry}
              onChange={(e) => setSelectedCountry(e.target.value)}
              className="country-select"
            >
              {Object.keys(CURRENCY_CONFIG)
                .sort()
                .map((country) => {
                  const countryConfig = CURRENCY_CONFIG[country];
                  return (
                    <option key={country} value={country}>
                      {country} ({countryConfig.code})
                    </option>
                  );
                })}
            </select>
          </label>
        </div>
        <div className="admin-field">
          <label>
            Currency
            <input
              type="text"
              value={`${currency.code} - Tax: ${(FIXED_TAX_RATE * 100).toFixed(0)}%`}
              readOnly
              className="read-only-input"
            />
          </label>
        </div>
      </div>
      <div className="currency-note" style={{ marginTop: "12px", padding: "12px", backgroundColor: "#f8f9fa", borderRadius: "6px", fontSize: "14px", color: "#6c757d" }}>
        <strong>Note:</strong> The final purchase price is displayed in the currency code of the selected country (CAD for Canada, GBP for European countries, USD for others). Prices remain the same - only the currency code changes. All amounts show currency code after the number (e.g., "100 CAD").
      </div>
    </div>

 

    {/* GLOBAL SEND BUTTON */}
    <div className="action-row global-action-row">
      <button
        type="button"
        className="primary"
        onClick={handleSendMail}
      >
        {!isLoggedIn ? "Please Login to Send" : "Send measurement emails"}
      </button>
      <div className="selection-summary">
        <p>Total looks: {looks.length}</p>
        <p>Total outfits (all looks): {totalQuantity}</p>
        
        {/* Pricing Breakdown */}
        <div className="pricing-breakdown">
          <div className="pricing-row" style={{ marginBottom: "8px" }}>
            <span><strong>Base Prices ({currency.code}):</strong></span>
          </div>
          <div className="pricing-row" style={{ paddingLeft: "16px", fontSize: "13px", color: "#6c757d" }}>
            <span>Customized Kurta (per unit):</span>
            <span>{formatCurrency(pricePerKurta, currency.code)} {currency.code}</span>
          </div>
          <div className="pricing-row" style={{ paddingLeft: "16px", fontSize: "13px", color: "#6c757d" }}>
            <span>Shawl (per unit, optional):</span>
            <span>{formatCurrency(pricePerShawl, currency.code)} {currency.code}</span>
          </div>
          <div className="pricing-row" style={{ paddingLeft: "16px", fontSize: "13px", color: "#6c757d", marginBottom: "12px" }}>
            <span>Price per complete outfit (Kurta + Pajama + optional Shawl):</span>
            <span>{formatCurrency(pricePerKurta + pricePerShawl, currency.code)} {currency.code} (varies by selection)</span>
          </div>
          {looksWithPrice.map((look, idx) => (
            <div key={look.id} className="pricing-row look-price-row">
              <span>{look.name} ({look.quantity} qty × {formatCurrency(look.pricePerUnit, currency.code)} {currency.code}):</span>
              <span>{formatCurrency(look.price, currency.code)} {currency.code}</span>
            </div>
          ))}
          <div className="pricing-row pricing-subtotal">
            <span>Subtotal:</span>
            <span>{formatCurrency(subtotal, currency.code)} {currency.code}</span>
          </div>
          <div className="pricing-row" style={{ paddingLeft: "16px", fontSize: "13px", color: "#6c757d" }}>
            <span>Tax ({selectedCountry === "United States" ? "Sales Tax" : selectedCountry === "Canada" ? "HST/GST" : selectedCountry === "Australia" ? "GST" : selectedCountry === "Hong Kong" ? "No Tax" : "VAT"}) ({(FIXED_TAX_RATE * 100).toFixed(0)}%):</span>
            <span>{formatCurrency(taxAmount, currency.code)} {currency.code}</span>
          </div>
          <div className="pricing-row pricing-shipping">
            <span>Shipping Charges:</span>
            <span>{formatCurrency(shippingCharges, currency.code)} {currency.code}</span>
          </div>
          <div className="pricing-row pricing-total">
            <span><strong>Total Amount ({currency.code}):</strong></span>
            <span><strong>{formatCurrency(totalAmount, currency.code)} {currency.code}</strong></span>
          </div>
          <div className="currency-note" style={{ marginTop: "12px", padding: "10px", backgroundColor: "#e7f3ff", borderRadius: "6px", fontSize: "12px", color: "#0066cc", fontStyle: "italic" }}>
            * Final purchase price is displayed in {currency.code} based on the shipping destination ({selectedCountry}). All prices remain exactly the same - only the currency code changes.
          </div>
        </div>

        {statusMessage && (
          <span className="status">{statusMessage}</span>
        )}
      </div>
    </div>
    
    <ToastContainer />

  </div>

);
};

export default KurtaPajamaShowcase;
